import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {},
  filled: {},
  positionStart: {},
  positionEnd: {},
  disablePointerEvents: {},
  hiddenLabel: {},
  marginDense: {},
})
export default styleOverride
